import React, { useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BaseUrl } from "../Routes/BaseUrl";
import { toast } from "react-toastify";
import { Col, Row, Form, Button } from "@themesberg/react-bootstrap";
import JoditEditor from "jodit-react";

const InputField = ({ label, name, control, rules, type = "text" }) => (
  <Form.Group className="mb-3">
    <Form.Label>{label}</Form.Label>
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <>
          <Form.Control {...field} type={type} isInvalid={!!error} />
          <Form.Control.Feedback type="invalid">{error?.message}</Form.Control.Feedback>
        </>
      )}
    />
  </Form.Group>
);

const JoditEditorField = ({ label, name, control, rules }) => {
  const editor = useRef(null);
  return (
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <JoditEditor ref={editor} onChange={(newContent) => field.onChange(newContent)} />
        )}
      />
    </Form.Group>
  );
};

const SelectField = ({ label, name, control, rules, options }) => (
  <Form.Group className="mb-3">
    <Form.Label>{label}</Form.Label>
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <>
          <Form.Select {...field} isInvalid={!!error}>
            <option value="">Select {label}</option>
            {options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </Form.Select>
          <Form.Control.Feedback type="invalid">{error?.message}</Form.Control.Feedback>
        </>
      )}
    />
  </Form.Group>
);

export const AddProductComponent = () => {
  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const categories = ['Skin care', 'Hair Care', 'Baby and Mom care', 'Sexual Wellness', 'Oral Care'];

  const onSubmit = async (data) => {
    try {
      const formDataToSend = new FormData();
      
      // Add basic fields
      formDataToSend.append("name", data.titleName);
      formDataToSend.append("description", data.description || data.introduction || "");
      formDataToSend.append("price", data.prize);
      formDataToSend.append("category", data.category || "Skin care");
      formDataToSend.append("subCategory", data.subCategory || "");
      formDataToSend.append("brand", data.brand);
      formDataToSend.append("stock", data.noOfStrips || 0);
      formDataToSend.append("unit", "piece");

      // Add image if provided
      if (data.productImages?.length) {
        formDataToSend.append("image", data.productImages[0]);
      }

      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${BaseUrl.trim()}/admin/products`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        toast.success("Product created successfully");
        navigate("/ProductList");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <h5 className="mb-4">Create Product</h5>
      <Row>
        <Col md={6}><InputField label="Product Name" name="titleName" control={control} rules={{ required: "Name is required" }} /></Col>
        <Col md={6}><InputField label="Price (Rs)" name="prize" control={control} type="number" rules={{ required: "Price is required" }} /></Col>
      </Row>
      <Row>
        <Col md={6}>
          <SelectField
            label="Category"
            name="category"
            control={control}
            rules={{ required: "Category is required" }}
            options={categories}
          />
        </Col>
        <Col md={6}><InputField label="Sub Category" name="subCategory" control={control} /></Col>
      </Row>
      <Row>
        <Col md={6}><InputField label="Brand" name="brand" control={control} rules={{ required: "Brand is required" }} /></Col>
        <Col md={6}><InputField label="Stock Quantity" name="noOfStrips" control={control} type="number" /></Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Product Image</Form.Label>
            <Controller
              name="productImages"
              control={control}
              render={({ field }) => (
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => setValue("productImages", e.target.files)}
                />
              )}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <Form.Control as="textarea" rows={4} {...field} />
              )}
            />
          </Form.Group>
        </Col>
      </Row>
      <div className="d-flex gap-2">
        <Button type="submit" variant="success">Create Product</Button>
        <Button variant="secondary" onClick={() => navigate("/ProductList")}>Cancel</Button>
      </div>
    </Form>
  );
};
